export const mapTheme = (theme): Content.Theme => {
	if (!theme) {
		return null;
	}

	return {
		documentType: theme.contentType,
		name: theme.name,
		properties: {
			className: theme.properties.className ?? null,
		},
	};
};

export const mapFirstTheme = (themes: { theme }[]): Content.Theme => {
	if (!themes) {
		return null;
	}

	return mapTheme(themes.find((x) => x !== undefined));
};

export const mapThemes = (themes: { theme }[]): Content.Theme[] => {
	if (!themes) {
		return null;
	}

	return themes.map((theme) => {
		return mapTheme(theme);
	});
};
